// extracted by mini-css-extract-plugin
module.exports = {"container":"DayWisePlan_container__3inpN","tableView":"DayWisePlan_tableView__1j2VQ","footer":"DayWisePlan_footer__otTyo","footerButton":"DayWisePlan_footerButton__2-NXx"};